import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

// страницы
import { ClassroomResolver } from './_resolvers';
import { ClassroomContentPageComponent } from './classroom-content-page/classroom-content-page.component';
import { ClassroomMeetingsPageComponent } from './classroom-meetings-page/classroom-meetings-page.component';
import { ClassroomPageComponent } from './classroom-page.component';
import { ClassroomParticipantsPageComponent } from './classroom-participants-page/classroom-participants-page.component';

// резолверы

/**
 * Этот роут срабатывает после ленивой загрузки модуля по роуту /classrooms/:slug
 *
 * @see ClassroomsRoutingModule
 */
const routes: Routes = [
  {
    path: '',
    component: ClassroomPageComponent,
    resolve: {
      classroom: ClassroomResolver,
    },
    children: [
      {
        path: 'meetings',
        component: ClassroomMeetingsPageComponent,
      },
      {
        path: 'content',
        component: ClassroomContentPageComponent,
      },
      {
        path: 'participants',
        component: ClassroomParticipantsPageComponent,
      },
      {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'meetings',
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [ClassroomResolver],
})
export class ClassroomPageRoutingModule {}
